var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafePalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_924_6115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 26.5V29C39 36 28.8 40 25.7 41L24.6 41.4V37.1L25.2 36.9C30.1 35.1 35 32 35 29V26.5H39ZM23.5 6L27.7 7.3V11.7L23.5 10.4L23.2 10.5V20.4H27.6V24.5H23.2V41.3L22 40.9C21.5 40.7 20.6 40.4 19.5 39.9L19 39.7V7.3L23.5 6ZM17.8 7.8V12.2L12.1 13.9V20.4H17.8V39.3L16.5 38.7C12.6 36.7 8 33.4 8 28.7V26.5H12.1V28.7C12.1 29.7 12.6 30.7 13.6 31.7V24.5H8V10.7L17.8 7.8ZM28.9 7.7L38.9 10.8V24.6H33V30.6C33 30.6 31.7 32.3 28.9 33.7C28.9 32.9 28.9 20.8 28.9 13.4V7.7ZM33.1 13.3V20.4H34.9V13.9L33.1 13.3Z",
    fill: "#3A78FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_924_6115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 35.4,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePalLogo);
export default __webpack_public_path__ + "static/media/safePalLogo.a07aaca8.svg";
export { ForwardRef as ReactComponent };